export const maxCampaignNameLength = 45;
export function truncateName(name, maxLength = maxCampaignNameLength) {
    if (name.length > maxLength) {
        return name.substring(0, maxLength) + '...';
    }
    return name;
}
